import { Language } from '@shure/shared/angular/data-access/system-api/core';
import { LanguageCode } from '@shure/shared/models';

/**
 * List of default languages mapped inside sysapi
 */

// currently mono repo ui is supporting  more languages than the sys api
// so for some of them the mapping is undefined
const languageCodeToLanguageMap: { [key in LanguageCode]: Language | undefined } = {
	[LanguageCode.Arabic]: Language.Ar,
	[LanguageCode.ChineseSimple]: Language.ZhCn,
	[LanguageCode.ChineseTraditional]: undefined, // No equivalent
	[LanguageCode.English]: Language.En,
	[LanguageCode.French]: Language.Fr,
	[LanguageCode.German]: Language.De,
	[LanguageCode.Italian]: Language.It,
	[LanguageCode.Japanese]: Language.Ja,
	[LanguageCode.Korean]: Language.Ko,
	[LanguageCode.Portuguese]: Language.PtBr,
	[LanguageCode.Russian]: Language.Ru,
	[LanguageCode.Spanish]: Language.Es,
	[LanguageCode.Dutch]: undefined, // No equivalent
	[LanguageCode.Indonesian]: undefined // No equivalent
};

const languageToLanguageCodeMap: { [key in Language]: LanguageCode } = {
	[Language.Ar]: LanguageCode.Arabic,
	[Language.De]: LanguageCode.German,
	[Language.En]: LanguageCode.English,
	[Language.Es]: LanguageCode.Spanish,
	[Language.Fr]: LanguageCode.French,
	[Language.It]: LanguageCode.Italian,
	[Language.Ja]: LanguageCode.Japanese,
	[Language.Ko]: LanguageCode.Korean,
	[Language.PtBr]: LanguageCode.Portuguese,
	[Language.Ru]: LanguageCode.Russian,
	[Language.ZhCn]: LanguageCode.ChineseSimple
};

export function mapLanguageCodeToSysApi(languageCode: LanguageCode): Language | undefined {
	return languageCodeToLanguageMap[languageCode];
}

export function mapLanguageCodeFromSysApi(language: Language): LanguageCode {
	return languageToLanguageCodeMap[language];
}
